import { useCallback, useEffect, useState } from 'react'

import { showLoading } from 'services/util'

import { handleEscapeKey } from 'sites/auctions/components/utils'
import NumberRow from './NumberRow'
import css from '../../components/sass/confirmmodal.module.scss'
import themeCss from '../../components/sass/theme.module.scss'
import { getUserPurchases } from '../auctionsadminutil';

export default function ConfirmMarkFixedItemAsPaid({setShowConfirmModal, updateFixedItem, data}) {

  const loggedInUser = data.loggedInUser
  const [fixedItemTitle, setFixedItemTitle] = useState()
  const [purchasedQuantity, setPurchasedQuantity] = useState()

  const toggleModal = useCallback(() => {
      setShowConfirmModal(false)
    }, [setShowConfirmModal])
  
  useEffect(() => {
    const onKeyDown = (event) => handleEscapeKey(event, toggleModal)
    //add event listener for when modal is mounted
    document.addEventListener('keydown', onKeyDown)
    //clean up when modal is unmounted
    return () => document.removeEventListener('keydown', onKeyDown)

  }, [toggleModal])

  useEffect(() => {

    const userPurchaseQuantity = getUserPurchases(data.userId, data.auctionDetail)
      .filter(ele => ele.FixedItemId === data.fixedItemsMarkedPaid[0])
      .map(ele => ele.Quantity)[0]

    setPurchasedQuantity(userPurchaseQuantity)

    //use effect to set the title for the mark as paid window
    if (data?.auctionDetail) {
      const matchingFixedItem = data.auctionDetail.FixedItems.find(ele => ele.FixedItemId === data.fixedItemsMarkedPaid[0])
      setFixedItemTitle(matchingFixedItem.Title)
    }
  }, [data])

  const performConfirm = (test) => {

    const input = { FixedItemId: data.fixedItemsMarkedPaid[0] }
    
    const currentItem = data.auctionDetail.FixedItems.find(ele => ele.FixedItemId === data.fixedItemsMarkedPaid[0])
    const currentPayments = (currentItem.Payments || []).map((payment) => ({
      UserId: payment.UserId,
      Quantity: payment.Quantity,
      PaymentDetails: payment.PaymentDetails,
    }))
    
    const newPayment = {
      UserId: data.userId,
      Quantity: purchasedQuantity,
      PaymentDetails: JSON.stringify({ message: "Marked as paid by admin: " + loggedInUser.cognitoUser.username })
    }

    input['Payments'] = [...currentPayments, newPayment]

    showLoading(true)
    updateFixedItem(input)
  }

  return (
    <div className={css['modal-container']}>
      <div className={themeCss['modal-background']} onClick={()=>toggleModal()}> </div>
      <div className={`${css['modal-content']} }`}>

        <div>
          <div className={css['withdata-text']}>
            <h3>CONFIRM MARKING ITEMS AS PAID</h3>

            {data.fixedItemsMarkedPaid && <>
              <div className={css['number-row']}><h4>{fixedItemTitle?.toUpperCase()}</h4><p>BEING MARKED AS PAID FOR {data?.attendeeName?.toUpperCase()}</p></div>
              <NumberRow number={purchasedQuantity} dollar={false} text={'ITEM QUANTITY BEING MARKED AS PAID'} />
              <NumberRow number={data.totalMarkedPaid} dollar={true} text={'TOTAL BEING MARKED AS PAID'} />
            </>}
            
          </div> 
        </div>

        {/* {data.errorMessage && <p>Error</p>} */}

        <div className={css['button-options']}>
          <button className={`${themeCss['button']} ${themeCss['FilledWhite']} ${themeCss['centered-button']}`}
            onClick={()=>toggleModal()}>Cancel</button>          
          <button className={`${themeCss['FilledBlue']} ${themeCss['button']} ${themeCss['centered-button']} ${css['modal-buttontext-fixing']}`} 
            onClick={()=> performConfirm()}>Confirm Mark As Paid</button>
          
          {/* 
          //leave in for testing purposes
          <button 
            className={`${themeCss['FilledYellow']} ${themeCss['button']} ${themeCss['centered-button']} ${css['modal-buttontext-fixing']}`} 
            onClick={()=> performConfirm(true)}>Test-Unpaid</button> */}

        </div>
      </div>    
    </div>
  )
}
